import { useState } from "react"
import { useLoaderData, useLocation, useNavigate, useOutletContext } from "react-router-dom"
import { useAuth } from "contexts/auth-context"
import { useLayoutEffect } from "react"
import Form from "./form"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import { Transition } from "components"
import { executeAPI, useResultSet } from "repositories/db-repository"
import { lang } from "config"
import { getIsAdmin, getIsSupervisor, getIsOwner, getParameter } from "helpers/general-helper"
import { updatePurchaseTransaction } from "helpers/transaction-helper"

export default function Edit() {
    const { user } = useAuth()
    const { cache } = useSWRConfig()

    const { setTransition } = usePage()

    const { setTitle } = useOutletContext()

    const dataFromLoader = useLoaderData()

    const generatePUList = () => {
        var pu_list = "";

        if (dataFromLoader?.purchase_item_side_by_side?.length > 0) {
            for (var i = 0; i < dataFromLoader?.purchase_item_side_by_side?.length; i++) {
                pu_list = ",'" + dataFromLoader?.purchase_item_side_by_side[i].product_unit_id + "'" + pu_list
            }
            pu_list = pu_list.substring(1, pu_list.length)
        }

        return pu_list
    }
    const { data: stockSelection } = useResultSet(`${process.env.REACT_APP_REMAX_HQ_INVENTORY_API_URL}`, `stock_list`, {product_unit_id_list: generatePUList()})


    const location = useLocation()
    const navigate = useNavigate()

    const [prevRouteState, setPrevRouteState] = useState({})

    const [errors, setErrors] = useState({})

    // const user_role = getUserRole() 
    const is_admin = getIsAdmin()
    const is_supervisor = getIsSupervisor()
    const is_owner = getIsOwner()
    const ppn_percentage = parseInt(getParameter("PPN_PERCENTAGE"))

    useLayoutEffect(() => {
        const getPrevRouteState = async () => {
            setPrevRouteState({
                back: location.state?.back,
                from: location.state?.from,
                transition: location.state?.transition
            })
        }

        setTransition(location.state?.transition)
        if (((dataFromLoader?.purchase_transaction?.latest_flow_detail_id == "PURCHASE_REQUEST_DRAFT" ||
        dataFromLoader?.purchase_transaction?.latest_flow_detail_id == "PURCHASE_REQUEST_REJECTED") && is_admin == 1)) {
            setTitle(`Edit ${dataFromLoader?.purchase_transaction?.id}`)
        } else if (((dataFromLoader?.purchase_transaction?.latest_flow_detail_id == "PURCHASE_REQUEST_NEED_REVIEW" || 
        dataFromLoader?.purchase_transaction?.latest_flow_detail_id == "PURCHASE_REQUEST_IN_REVIEW" ||
        dataFromLoader?.purchase_transaction?.latest_flow_detail_id == "PURCHASE_ORDER_REJECTED") && 
            is_supervisor == 1)) {
                dataFromLoader.purchase_transaction.latest_flow_detail_id =  "PURCHASE_REQUEST_IN_REVIEW";
            executeAPI(`${process.env.REACT_APP_REMAX_PS_API_URL}`, "update_purchase_transaction", 
            {
                id: dataFromLoader?.purchase_transaction?.id,
                latest_flow_detail_id: "PURCHASE_REQUEST_IN_REVIEW",
                flow_detail_id: "PURCHASE_REQUEST_IN_REVIEW",
                record_status: "U",
                updated_by: user?.name
            },
            () => {}, () => {})
            setTitle(`Review ${dataFromLoader?.purchase_transaction?.id}`)
        } else if (((dataFromLoader?.purchase_transaction?.latest_flow_detail_id == "PURCHASE_REQUEST_APPROVED" || 
        dataFromLoader?.purchase_transaction?.latest_flow_detail_id == "PURCHASE_ORDER_IN_REVIEW") && 
            is_owner == 1)) {
                dataFromLoader.purchase_transaction.latest_flow_detail_id = "PURCHASE_ORDER_IN_REVIEW";
            executeAPI(`${process.env.REACT_APP_REMAX_PS_API_URL}`, "update_purchase_transaction", 
            {
                id: dataFromLoader?.purchase_transaction?.id,
                latest_flow_detail_id: "PURCHASE_ORDER_IN_REVIEW",
                flow_detail_id: "PURCHASE_ORDER_IN_REVIEW",
                record_status: "U",
                updated_by: user?.name
            },
            () => {}, () => {})
            setTitle(`Review ${dataFromLoader?.purchase_transaction?.id}`)
        } else {
            setTitle(`View ${dataFromLoader?.purchase_transaction?.id}`)
        }
        addCurrentStockInfo()
        getPrevRouteState()
    }, [stockSelection])

    const addCurrentStockInfo = () => {
        if (dataFromLoader?.purchase_item_side_by_side?.length > 0) {
            for (var i = 0; i < dataFromLoader?.purchase_item_side_by_side?.length; i++) {
                var row = dataFromLoader?.purchase_item_side_by_side[i]
                var tmp = stockSelection?.data?.find(item => item.product_unit_id == row.product_unit_id)
                if (tmp) {
                    row.current_stock = tmp.current_stock
                    row.pre_order = tmp.pre_order
                }
            }
        }
    }

    const updatePurchase = (data) => {

        const onSuccess = (result, message) => {
            cache.clear()
            navigate({ pathname: '/purchase' })
            if (data?.message) {
                toast.success(data?.message, {
                    id: "submit"
                })
            } else {
                toast.success("Purchase berhasil disimpan!", {
                    id: "submit"
                })
            }
        }

        const onError = (message) => {
            toast.error("onError: " + message, {
                id: "submit"
            })
        }

        if (data.warehouse_name && data.supplier_name && data.warehouse_address) {
            toast.loading("Processing Purchase...", {
                id: "submit"
            })
    
            updatePurchaseTransaction(data, user?.name, onSuccess, onError) 

        } else {
            setErrors({
                outlet_name: data.outlet_name ? undefined : lang.outlet_name + " " + lang.field_required,
                warehouse_name: data.warehouse_name ? undefined : lang.deliver_to + " " + lang.field_required,
                supplier_name: data.supplier_name ? undefined : lang.supplier_name + " " + lang.field_required,
                warehouse_address: data.warehouse_address ? undefined : lang.delivery_address + " " + lang.field_required,
            })
        }
    }

    const handleSubmit = (data) => {
        
        const onSuccess = (result, message) => {
            cache.clear()
            updatePurchase(data)
        }

        const onError = (message) => {
            toast.error("onError: " + message, {
                id: "submit"
            })
        }

        if (data.warehouse_name && data.supplier_name && data.warehouse_address) {
            if (data?.latest_flow_detail_id == "PURCHASE_ORDER_SENT") {
                const psPurchaseHeader = JSON.parse(data?.arr_purchase_header)

                executeAPI(`${process.env.REACT_APP_REMAX_SS_API_URL}`, "send_sales_transaction", 
                {
                    id: data?.id,
                    origin: data?.origin,
                    outlet_group_id: data?.outlet_group_id,
                    outlet_group_name: data?.outlet_group_name,
                    outlet_group_phone_number: data?.outlet_group_phone_number,
                    outlet_group_email_address: data?.outlet_group_email_address,
                    public_id: data?.public_id,
                    user_id: data?.outlet_group_id,
                    user_name: data?.outlet_group_name,
                    outlet_id: data?.outlet_id,
                    outlet_name: data?.outlet_name,
                    outlet_phone_number: data?.outlet_phone_number,
                    outlet_email_address: data?.outlet_email_address,
                    latest_flow_detail_id: "SALES_REQUEST_DRAFT",
                    sales_header_id: data?.purchase_header_id,
                    warehouse_id: data?.warehouse_id,
                    warehouse_name: data?.warehouse_name,
                    warehouse_address: data?.warehouse_address,
                    supplier_id: data?.supplier_id,
                    supplier_name: data?.supplier_name,
                    supplier_phone_number: data?.supplier_phone_number,
                    supplier_email_address: data?.supplier_email_address,
                    supplier_address: data?.supplier_address,
                    notes: data?.notes,
                    flow_detail_id: "SALES_REQUEST_DRAFT",
                    currency_id: data?.currency_id,
                    rate: data?.rate,
                    amount: psPurchaseHeader?.amount,
                    discount_amount: psPurchaseHeader?.discount_amount,
                    nett_amount: psPurchaseHeader?.nett_amount, 
                    dpp_amount: psPurchaseHeader?.dpp_amount,
                    ppn_amount: psPurchaseHeader?.ppn_amount,
                    ppn_percentage: data?.ppn_percentage,
                    arr_sales_item: data?.arr_purchase_item
                },
                onSuccess, onError)
            } else if (data?.latest_flow_detail_id == "SALES_ORDER_DELIVERY_RETURN" ||
            data?.latest_flow_detail_id == "SALES_ORDER_CLOSED") {
                executeAPI(`${process.env.REACT_APP_REMAX_SS_API_URL}`, "send_received_transaction", 
                {
                    id: data?.id,
                    sales_header_id: data?.purchase_header_id,
                    latest_flow_detail_id: data?.latest_flow_detail_id,
                    arr_sales_header: data?.arr_purchase_header,
                    arr_sales_item: data?.arr_purchase_item
                },
                onSuccess, onError)
            } else if (data?.latest_flow_detail_id == "SALES_ORDER_COMPLETED") {
                // alert(JSON.stringify(data))
                executeAPI(`${process.env.REACT_APP_REMAX_GO_INVENTORY_API_URL}`, "process_data_to_inventory", 
                {
                    id: data?.id,
                    public_id: data?.public_id,
                    purchase_header_id: data?.purchase_header_id,
                    outlet_id: data?.outlet_id,
                    purchase_date: data?.entry_date,
                    arr_purchase_header: data?.arr_purchase_header,
                    arr_purchase_item: data?.arr_purchase_item
                },
                onSuccess, onError)
            } else {
                updatePurchase(data)
            }
        } else {
            setErrors({
                warehouse_name: data.warehouse_name ? undefined : lang.deliver_to + " " + lang.field_required,
                supplier_name: data.supplier_name ? undefined : lang.supplier_name + " " + lang.field_required,
                warehouse_address: data.warehouse_address ? undefined : lang.delivery_address + " " + lang.field_required,
            })
        }        
    }

    return (
        <Transition type="fade">
            <Form data={dataFromLoader} errors={errors} onSubmit={handleSubmit} />
        </Transition>
    )
}